export default "__VITE_ASSET__C8CIQcnk__"